export default "__VITE_ASSET__BiKXtUSq__"